import React, { Fragment } from 'react'

class CVSkill extends React.Component {
  render() {
    const { name, keywords } = this.props
    return (
      <Fragment>
        <h3 className="skills">{name}</h3>
        {keywords &&
          keywords.map(keyword => (
            <Fragment key={keyword}>
              <span key={keyword} className="keywords">
                {keyword}
              </span>{' '}
            </Fragment>
          ))}
      </Fragment>
    )
  }
}

export default CVSkill



// WEBPACK FOOTER //
// ./src/components/cv/CVSkill.js